export default __webpack_public_path__ + "static/media/fail.165138cb.svg";